import { IUITile } from '@/src/types/ITile';
import { create } from 'zustand';

interface TilesState {
  tiles: IUITile[];

  addTile: (tile: IUITile) => void;
  setTiles: (tiles: IUITile[]) => void;
  removeTile: (tileId: string) => void;
  updateTile: (tileId: string, updatedTile: Partial<IUITile>) => void;
  setTileLoading: (tileId: string, isLoading: boolean) => void;
}

export const useTilesStore = create<TilesState>((set, get) => ({
  tiles: [],
  setTiles: (tiles) =>
    set(() => ({ tiles: Array.isArray(tiles) ? tiles : [] })),
  addTile: (tile) =>
    set((state) => ({
      tiles: Array.isArray(state.tiles) ? [...state.tiles, tile] : [tile],
    })),
  removeTile: (tileId) =>
    set((state) => ({
      tiles: Array.isArray(state.tiles)
        ? state.tiles.filter((tile) => tile.i !== tileId)
        : [],
    })),
  setTileLoading: (tileId, isLoading) =>
    set((state) => ({
      tiles: Array.isArray(state.tiles)
        ? state.tiles.map((tile) =>
            tile.i === tileId ? { ...tile, isLoading } : tile
          )
        : [],
    })),
  updateTile: (id, updates) =>
    set((state) => ({
      tiles: Array.isArray(state.tiles)
        ? state.tiles.map((tile) =>
            tile.i === id ? { ...tile, ...updates } : tile
          )
        : [],
    })),
}));
